<template>
    <div class="cancellation-policy">
        <div class="title mb-3">
            {{voMsg('tpl.cancellation.title')}}
        </div>
        <ul class="tick-li">

            <li><span class="li-title">Stornierungsbedingungen:</span>
                <ul class="second-ul">
                    <li>Bis 29 Tage vor Anreise: 0 %</li>
                    <li>28–14 Tage vor Anreise: 50 %</li>
                    <li>13–0 Tage vor Anreise: 100 %</li>
                </ul>
            </li>
            <li><span class="li-title">Zahlungsbedingungen:</span>
                <ul class="second-ul">
                    <li>20 % Anzahlung bei Buchung</li>
                    <li>Überweisung</li>
                    <li>Kreditkarte</li>
                </ul>
            </li>
            <li><span class="li-title">{{voMsg('tpl.cancellation.bestPrice')}}</span>
                <br/>{{voMsg('tpl.cancellation.bestPriceWeb')}}
            </li>
            <li><span class="li-title">{{voMsg('tpl.cancellation.service')}}</span>
                <br/>{{voMsg('tpl.cancellation.emailService')}}
            </li>
            <li><span class="li-title">{{voMsg('tpl.cancellation.guestApp')}}</span>
                <br/>{{voMsg('tpl.cancellation.guestAppInfo')}}
            </li>
        </ul>
    </div>
</template>
<script>
    import V from 'voUtils/V.js';
    import DateEx from 'voUtils/DateEx.js';

    export default {
    	voVueComponent: 'cancellationpolicy',
    	props: {
    		policy: Object,
    		from: String,
    		translation: {
    			type: String,
    			default: 'Bis __DAYS__ Tage vor Anreise kostenlos stornierbar.'
    		},
    		translationdate: {
    			type: String,
    			default: 'Bis zum __DATE__ kostenlos stornierbar.'
    		}

    	},
    	data: function() {
    		return {
    			showDate: false,
    			showGeneral: false
    		};
    	},
    	computed: {

    		maxDaysBeforeArrival() {
    				if (!this.policy || !this.policy.byDaysTillArrival) {
    					return null;
    				}
    				return Math.max(...this.policy.byDaysTillArrival.map(p => p.daysBeforeArrival));
    			},
    			localizedText() {
    				if (this.showDate) {
    					const today = DateEx.interfaceFormat(DateEx.getToday());
    					let diff = DateEx.getDays(this.from, today);
    					if (diff < (this.maxDaysBeforeArrival + 1)) {
    						this.showDate = false;
    					} else {
    						const date = new Date(this.from);
    						date.setDate(date.getDate() - (this.maxDaysBeforeArrival + 1));
    						let lastDay = DateEx.formatDate(date.toISOString().split("T")[0], VOFFICE.mlang);
    						return this.translationdate.replace('__DATE__', lastDay);
    					}

    				} else {
    					return this.translation.replace('__DAYS__', (this.maxDaysBeforeArrival + 1));
    				}
    			}

    	},
    	mounted: function() {

    		//console.log('Policy::', this.policy);

    		if (this.policy && this.policy.byDaysTillArrival && !this.policy.defaultPenalty && !this.policy.cancellationFlatFee) {
    			if (!this.from) {
    				this.showGeneral = true;
    			} else if (this.from) {
    				this.showDate = true;
    			}
    		}
    	}

    };
</script>